import { render, staticRenderFns } from "./FontPicker.vue?vue&type=template&id=cd4a3236"
import script from "./FontPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./FontPicker.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports